<template>
  <footer class="footer has-background-primary-light ">
    All rights reserved
  </footer>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style>
</style>
